export default __webpack_public_path__ + "static/media/Banner5.1245b015.JPG";